export enum MethodType {
    POST      = "POST",
    GET       = "GET",
    PATCH     = "PATCH",
    DELETE    = "DELETE"
}